import { iBookingActivityLog } from "@sdk/bookings/booking-activity-log-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { bookingActivityLogsDefaultQueryConfig } from "./booking-activity-logs-default-query";

export const {
  slice: BookingActivityLogsSlice,
  reducers: BookingActivityLogsSliceReducer,
  actions: {
    setEntityQueryResults: setBookingActivityLogsQueryResults,
    setEntity: setBookingActivityLog,
    setEntities: setBookingActivityLogs,
    patchEntity: patchBookingActivityLog,
    addNewEntity: addNewBookingActivityLog,
    setEntityFetchingStatus: setBookingActivityLogFetchingStatus,
    setEntitiesFetchingStatus: setBookingActivityLogsFetchingStatus,
    setEntityFailedStatus: setBookingActivityLogFailedStatus,
    setEntityQueryError: setBookingActivityLogsQueryError,
    resetQuery: resetBookingActivityLogsQuery,
    setQueryList: setBookingActivityLogQueryList,
  },
} = CreateEntitySlice<iBookingActivityLog>({
  sliceName: "bookingActivityLogs",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...bookingActivityLogsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
